import { gql } from "@apollo/client"

export const CUSTOM_FORM = gql`
  query CustomForms(
    $staff_id: ID
    $idTemplate: ID!
    $participant_membership_id: ID
  ) {
    customForm: blocksSavedByIdTemplate(
      staff_id: $staff_id
      idTemplate: $idTemplate
      participant_membership_id: $participant_membership_id
      groupByIdStamp: true
    ) {
      data
    }
  }
`

export const CUSTOM_FORM_BY_PARTICIPANT = gql`
  query CustomFormParticipant(
    $participant_id: ID!
    $organization_id: ID!
    $idTemplate: ID!
    $participant_membership_id: ID
  ) {
    customForm: blocksSavedByParticipantIdTemplate(
      participant_id: $participant_id
      organization_id: $organization_id
      idTemplate: $idTemplate
      participant_membership_id: $participant_membership_id
      groupByIdStamp: true
    ) {
      data
    }
  }
`

export const ACTIVITY_LOG_STAFF = gql`
  query ActivityLogGetUser($staff_id: ID!) {
    user(staff_id: $staff_id) {
      staff_id
      staff_name_first
      staff_name_last
    }
  }
`

export const GET_BLOCK_ASSESSMENT_8_ASSESMENT = gql`
  query EightAssesment($staff_id: String!, $participant_membership_id: ID) {
    Eightassesment: getSpecificBlocksByMembership(
      participant_membership_id: $participant_membership_id
      blocks: ["form", "form__assessment_8_dimensions"]
    ) {
      data
    }
    templateNames: templates(type: "system", staff_id: $staff_id) {
      template_name
      template_title
    }
  }
`
